import { Injectable } from '@angular/core';
import { MenuStrategy } from "./MenuStrategy";
import { EmptyMenuStrategy } from './menustrategies/empty-MenuStrategy';
import { HomeMenuStrategy } from "./menustrategies/home-MenuStrategy";
import { LoginMenuStrategy } from "./menustrategies/login-MenuStrategy";
import { UtenteMenuStrategy } from "./menustrategies/utente-MenuStrategy";
import { CambioPasswordMenuStrategy } from "./menustrategies/cambio-password-MenuStrategy";
import { ScollegamentoUtenteMenuStrategy } from "./menustrategies/scollegamento-utente-MenuStrategy";
import { ImpostazioniMenuStrategy } from "./menustrategies/impostazioni-MenuStrategy";
import { GestioneUtentiMenuStrategy } from "./menustrategies/gestione-utenti-MenuStrategy";
import { DispositiviMenuStrategy } from './menustrategies/dispositivi-MenuStrategy';
import { DispositiviListaDispositiviMenuStrategy } from './menustrategies/dispositivi-lista-dispositivi-MenuStrategy';
import { DispositiviGestioneDispositiviMenuStrategy } from './menustrategies/dispositivi-gestione-dispositivi-MenuStrategy';
import { DispositiviStoricoMenuStrategy } from './menustrategies/dispositivi-storico-Menustrategy';
import { EliminaAccountMenuStrategy } from './menustrategies/elimina-account-MenuStrategy';

@Injectable({
  providedIn: 'root'
})
export class MenuFactory {
  private strategyMap: { [key: string]: MenuStrategy } = {};

  constructor() {
    this.strategyMap = {};
    this.strategyMap[''] = new EmptyMenuStrategy();
    this.strategyMap['Home'.toLowerCase()] = new HomeMenuStrategy();
    this.strategyMap['Utente'.toLowerCase()] = new UtenteMenuStrategy();
    this.strategyMap['Login'.toLowerCase()] = new LoginMenuStrategy();
    this.strategyMap['Cambio Password'.toLowerCase()] = new CambioPasswordMenuStrategy();
    this.strategyMap['Scollegamento Utente'.toLowerCase()] = new ScollegamentoUtenteMenuStrategy();
    this.strategyMap['Elimina Account'.toLowerCase()] = new EliminaAccountMenuStrategy();
    this.strategyMap['impostazioni'.toLowerCase()] = new ImpostazioniMenuStrategy();
    this.strategyMap['Gestione Utenti'.toLowerCase()] = new GestioneUtentiMenuStrategy();

    this.strategyMap['Dispositivi'.toLowerCase()] = new DispositiviMenuStrategy();
    this.strategyMap['Lista Dispositivi'.toLowerCase()] = new DispositiviListaDispositiviMenuStrategy();
    this.strategyMap['Gestione Dispositivi'.toLowerCase()] = new DispositiviGestioneDispositiviMenuStrategy();
    this.strategyMap['Storico'.toLowerCase()] = new DispositiviStoricoMenuStrategy();

    // Aggiungi altre strategie alla mappa...
  }

  createStrategy(menuName: string): MenuStrategy {
    const strategy = this.strategyMap[menuName.toLowerCase()];
    // if (!strategy) {
    //   console.log(`No strategy found for menu: ${menuName}`);
    // }
    return strategy;
  }

}
